import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OpcaoMenu } from '../../shared/menus/opcao-menu.interface';

export enum IconeAtivo {
  ANDARILHO = 'iconeAndarilho',
  QUALIDADE = 'iconeQualidade',
  MOEDAS = 'iconeMoedas',
  FINANCEIRO = 'iconeFinanceiro',
}
@Injectable({
  providedIn: 'root',
})
export class LayoutEditorContentService {
  private tituloMenuLateral = new BehaviorSubject<string>('');
  private opcoesMenuLateralAtivas = new BehaviorSubject<OpcaoMenu[]>([]);
  private opcoesMenuLateralInativas = new BehaviorSubject<OpcaoMenu[]>([]);
  private caminhoImagem = new BehaviorSubject<string>('');
  private corFundoMenuLateral = new BehaviorSubject<string>('');
  private exibirBotaoAnterior = new BehaviorSubject<boolean>(false);
  private rotaAnterior = new BehaviorSubject<string>('');
  private exibirBotaoProximo = new BehaviorSubject<boolean>(false);
  private rotaProximo = new BehaviorSubject<string>('');
  private exibirResultado = new BehaviorSubject<boolean>(false);
  private iconeAtivo = new BehaviorSubject<IconeAtivo>(IconeAtivo.ANDARILHO);

  tituloMenuLateral$ = this.tituloMenuLateral.asObservable();
  opcoesMenuLateralAtivas$ = this.opcoesMenuLateralAtivas.asObservable();
  opcoesMenuLateralInativas$ = this.opcoesMenuLateralInativas.asObservable();
  caminhoImagem$ = this.caminhoImagem.asObservable();
  corFundoMenuLateral$ = this.corFundoMenuLateral.asObservable();
  exibirBotaoAnterior$ = this.exibirBotaoAnterior.asObservable();
  exibirBotaoProximo$ = this.exibirBotaoProximo.asObservable();
  rotaAnterior$ = this.rotaAnterior.asObservable();
  rotaProximo$ = this.rotaProximo.asObservable();
  exibirResultado$ = this.exibirResultado.asObservable();
  iconeAtivo$ = this.iconeAtivo.asObservable();

  definirTituloMenuLateral(titulo: string): void {
    this.definirExibirResultado(false);
    this.tituloMenuLateral.next(titulo);
  }

  definiOpcaoAtivaSelecionada(index: number): void {
    const opcoes = this.opcoesMenuLateralAtivas.getValue();
    opcoes.forEach((opcao) => {
      opcao.selecionado = false;
    });
    opcoes[index].selecionado = true;
    this.definirOpcoesAtivas(opcoes);
  }

  definirOpcoesAtivas(opcoes: OpcaoMenu[]): void {
    this.opcoesMenuLateralAtivas.next(opcoes);
  }

  definirOpcoesInativas(opcoes: OpcaoMenu[]): void {
    this.opcoesMenuLateralInativas.next(opcoes);
  }

  definirCaminhoImagem(caminho: string): void {
    this.caminhoImagem.next(caminho);
  }

  definirCorFundoMenuLateral(cor: string): void {
    this.corFundoMenuLateral.next(cor);
  }

  definirExibirBotaoAnterior(exibir: boolean): void {
    this.exibirBotaoAnterior.next(exibir);
  }

  definirExibirBotaoProximo(exibir: boolean): void {
    this.exibirBotaoProximo.next(exibir);
  }

  definirRotaAnterior(rota: string): void {
    this.rotaAnterior.next(rota);
  }

  definirRotaProximo(rota: string): void {
    this.rotaProximo.next(rota);
  }

  definirExibirResultado(exibir: boolean): void {
    this.exibirResultado.next(exibir);
  }

  definirIconeAtivo(icone: IconeAtivo): void {
    this.iconeAtivo.next(icone);
  }
}
